import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {UncontrolledTooltip} from 'reactstrap';
import {typeKaraoke, typeStandard} from "../constants/default";

const AddSongButton = ({togModalAddSong, eventType, eventSongListMetaData}) => {
  const { t } = useTranslation();

  const limitSongOnListReached = eventSongListMetaData.limitSongOnListReached ?? false;
  const limitSongOnListPerUserReached = eventSongListMetaData.limitSongOnListPerUserReached ?? false;
  const limitSongsInLineReached = eventSongListMetaData.limitSongsInLineReached ?? false;

  const limitReached = eventType === typeKaraoke
    ? (limitSongOnListReached || limitSongOnListPerUserReached || limitSongsInLineReached)
    : (limitSongOnListReached || limitSongOnListPerUserReached);

  const message = (() => {
    if (limitSongsInLineReached && eventType === typeKaraoke) {
      return 'Your limit for songs in a row has been reached';
    }
    if (limitSongOnListPerUserReached && eventType === typeKaraoke) {
      return 'Your song limit on this list has been reached';
    }
    if (limitSongOnListPerUserReached && eventType === typeStandard) {
      return 'Your votes limit on this list has been reached';
    }
    if (limitSongOnListReached) {
      return 'Song limit reached';
    }
    return '';
  })();

  const [tooltipOpen, setTooltipOpen] = useState(false);

  useEffect(() => {
    if (tooltipOpen) {
      const timer = setTimeout(() => setTooltipOpen(false), 1500);
      return () => clearTimeout(timer);
    }
  }, [tooltipOpen]);

  return (
    <>
      <div
        style={{display: 'inline-block'}}
        id='add-song-button'
      >
        <button
          className="btn bg-transparent border-0 shadow-none color-primary d-inline-flex align-items-center px-2 py-0 me-1"
          onClick={togModalAddSong}
          disabled={limitReached}
          style={limitReached ? {pointerEvents: 'none'} : {}}
        >
          <i className="ri-add-circle-line align-middle me-2" style={{ fontSize: '1.6rem' }}></i>
          {t('Add Song To List')}
        </button>
      </div>

      {limitReached && (
        <UncontrolledTooltip
          placement="right"
          target="add-song-button"
          trigger="click"
          isOpen={tooltipOpen}
          toggle={() => setTooltipOpen(!tooltipOpen)}
        >
          {t(message)}
        </UncontrolledTooltip>
      )}
    </>
  );
};

export default AddSongButton;
